// /submit surface events: real rooms joining the dataset.
//
// Its own module for the same reason onboardingAnalytics.js is: these fire on
// a standalone page that has no league, no draft and no funnel in common with
// the mock/projlab/live modules.
//
// Gating is inherited: analyticsGate.js stubs posthog.capture entirely when
// analytics is suppressed, so no host or env checks belong here.

import posthog from "posthog-js";

// Never let analytics break a submission — swallow capture failures.
function safeCapture(event, properties) {
  try {
    posthog.capture(event, properties);
  } catch {
    /* ignore */
  }
}

/**
 * Fired once per accepted Sleeper submission.
 *
 * 🔴 NOTHING IDENTIFYING GOES IN THE EVENT — no league id, no league name, no
 * email. The page promises the submission is used in aggregate only, and an
 * analytics property is not exempt from that promise. `season` and `duplicate`
 * are the two facts worth knowing: which seasons the funnel actually brings in,
 * and how much of the traffic is the same room pasted twice.
 */
export function captureLeagueSubmitted({ season, duplicate }) {
  safeCapture("league_submitted", {
    season: season || null,
    duplicate: !!duplicate,
  });
}

/**
 * Fired once per completed Yahoo/ESPN/other upload, after the LAST file lands.
 *
 * 🔴 NO BLOB URLS, and no note text. Same promise as above: the shape of the
 * room is what is worth knowing — which platforms actually convert, and whether
 * people send one screenshot or eight. The files themselves are a private-store
 * object that a person reads, not an analytics property.
 */
export function captureResultsSubmitted({ platform, teams, format, fileCount }) {
  safeCapture("results_submitted", {
    platform: platform || "unknown",
    teams: Number.isFinite(teams) ? teams : null,
    format: format || null,
    fileCount: Number.isFinite(fileCount) ? fileCount : null,
  });
}
